import Page from "../framework/Page";
import View from "../framework/View";

export default class HeaderView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {string} headerText 
     */
    constructor(parentId, elementId, headerText) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {string}
         */
        this.headerText = headerText;

        /**
         * @type {HTMLElement}
         */
        this.headerElement = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {
        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('HeaderView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.headerElement = Page.createElement('div', parent, this.elementId, 'header-panel');

        this.headerElement.innerHTML = this.headerText;

        super.initializeView();
    }


    // /**
    //  * @override
    //  */
    // updateViewContents() {
        
    // }

}